const ELEMENT_SELECTOR = '[data-a-modal]';

$(() => {
	if ($(ELEMENT_SELECTOR).length) {

		System.import(
			/* webpackChunkName: "a-modal-bundle" */ './a-modal-bundle'
		).then((module) => {
			module.default();
		});
	}
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/a-modal/index--split.js